import React from "react";

/**
 * Renders `text` so that a hyphenated compound ("Rendez-vous", "Carte-cadeau") is one
 * unbreakable unit. A hard hyphen is a line-break opportunity whatever `hyphens` says
 * (UAX #14), so in a narrow box the compound would otherwise split after its hyphen.
 *
 * The text is split on ASCII spaces only: each word containing a hyphen-minus is wrapped in a
 * `whitespace-nowrap` span, every other word stays plain text, so the label still wraps at its
 * spaces and a long hyphen-free word still hyphenates under the parent's `hyphens-auto`. The
 * bytes are never rewritten (no U+2011), so search, `<option>` text and screen readers read
 * the real hyphen.
 *
 * @param {{ text: string }} props  Empty or non-string text renders nothing.
 */
export const KeepCompounds = ({ text }) => {
  if (typeof text !== "string" || text === "") return null;
  const words = text.split(" ");
  return words.map((word, i) => (
    <React.Fragment key={i}>
      {i > 0 && " "}
      {word.includes("-") ? <span className="whitespace-nowrap">{word}</span> : word}
    </React.Fragment>
  ));
};

export default KeepCompounds;
